module.exports = __webpack_public_path__ + "img/phone-random-result.809b8d6d.webp";